import { byokFetch } from "./client";

export async function deleteByokKey(id: string): Promise<{ id: string; deleted: true }> {
  return byokFetch<{ id: string; deleted: true }>("byok-keys", `/${id}`, {
    method: "DELETE",
  });
}
